module.exports = __webpack_public_path__ + "static/adults_program_banner-cbf862bb4ad2c3e16c4a1a78edded830.jpg";